import axios from "axios";

export const controlEventReportApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/control-event-report`,
  headers: {
    "Content-Type": "application/json",
  },
});
